// material ui
import { Box, Chip, Typography } from '@mui/material';

const Kpi = ({
  value,
  unit,
  trend,
  trendColor = 'success',
  showTrend = true,
}) => {
  const formatted =
    value === null || value === undefined
      ? '-'
      : `${value}${unit ? ` ${unit}` : ''}`;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Typography variant="h3">{formatted}</Typography>
      {showTrend && trend !== undefined && (
        <Chip
          variant="outlined"
          label={trend}
          size="small"
          color={trendColor}
        />
      )}
    </Box>
  );
};

export default Kpi;
